export default {"src":"/_next/static/media/download.a081d6d0.svg","height":192,"width":192};